<template>
  <div id="app">
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      v-if="logueado"
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
    >
      <v-list dense>
        <template v-if="esAdministrador || esAlmacenero || esVendedor || esComprador ||  esContabilidad">
          <v-list-item :to="{ name: 'Home'}">
            <v-list-item-action>
              <v-icon>home </v-icon>
            </v-list-item-action>
            <v-list-item-title>
              Inicio
            </v-list-item-title>
          </v-list-item>          
        </template>
       <template v-if="esAdministrador || esAlmacenero || esVendedor|| esComprador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Archivo
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'cajeros'}">
              <v-list-item-action>
                <v-icon>people</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                    Cajero
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'departamentos'}">
              <v-list-item-action>
                <v-icon>location_city</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Departamentos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'documentos'}">
              <v-list-item-action>
                <v-icon>article</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Formularios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'ciudades'}">
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Ciudades
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'clasificaciones'}">
              <v-list-item-action>
                <v-icon>class</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Clasificaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'censosclientes'}">
              <v-list-item-action>
                <v-icon>view_list</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Censo Clientes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          <template v-if="esAdministrador">
            <v-list-group :value="false"
            no-action
            sub-group>
              <template>
              <v-list-item slot="activator">
                <v-list-item-content>
                  <v-list-item-title>
                    Maquinaria
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :to="{ name: 'equipomarcas'}">
              <v-list-item-action>
                <v-icon>branding_watermark</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Marca de Equipos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'equiposmodelos'}">
              <v-list-item-action>
                <v-icon>branding_watermark</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Modelos de Equipos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
              </template>
            </v-list-group>
          </template>

          </v-list-group>
        </template>

<template v-if="esAdministrador || esAlmacenero|| esComprador || esContabilidad ">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Contabilidad
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
             <v-list-item :to="{ name: 'periodo'}">
              <v-list-item-action>
                <v-icon>date_range</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                    Periodos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'gruposproyectos'}">
              <v-list-item-action>
                <v-icon>group_work</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                    Grupo Proyecto
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'proyectos'}">
              <v-list-item-action>
                <v-icon>adjust</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Proyecto
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                <v-list-item :to="{ name: 'seriedocumento'}">
              <v-list-item-action>
                <v-icon>description</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Documentos CAI
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
                    
          </v-list-group>
          
        </template>

<template v-if="esAdministrador || esAlmacenero || esComprador || esContabilidad ">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Banco
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'gruposproyectos'}">
              <v-list-item-action>
                <v-icon>account_balance</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                    Cuentas Bancarias
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'BanConcepto'}">
              <v-list-item-action>
                <v-icon>toc</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Conceptos Bancarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                <v-list-item :to="{ name: 'seriedocumento'}">
              <v-list-item-action>
                <v-icon>account_balance_wallet</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Transacciones Bancarias
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
                    
          </v-list-group>
          
        </template>

        
<template v-if="esAdministrador || esAlmacenero || esComprador || esContabilidad ">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Cuentas Por Cobrar
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'conceptocxc'}">
              <v-list-item-action>
                <v-icon>toc</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                    Conceptos CXC
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'documentocxc'}">
              <v-list-item-action>
                <v-icon>shopping_bag</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Movimientos De CXC 
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>                   
          </v-list-group>
          
        </template>


       <template v-if="esAdministrador || esAlmacenero || esComprador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Almacén
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                 <v-list-item :to="{ name: 'Almacenes'}">
              <v-list-item-action>
                <v-icon>store</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Almacenes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

                        
                 <v-list-item :to="{ name: 'Ubicaciones'}">
              <v-list-item-action>
                <v-icon>place</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Ubicaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'categorias'}">
              <v-list-item-action>
                <v-icon>category</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Categorías
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'productos'}">
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Aticulos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        
        <template v-if="esAdministrador|| esVendedor || esComprador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Ventas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'clientes'}">
              <v-list-item-action>
                <v-icon>people</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Clientes
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'vendedores'}">
              <v-list-item-action>
                <v-icon>table_chart</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Vendedores
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                  <v-list-item :to="{ name: 'cotizaciones'}">
              <v-list-item-action>
                <v-icon>request_quote</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Cotizaciones
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
    
        <template v-if="esAdministrador|| esComprador || esComprador ">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Compras
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'ClasiProovedor'}">
              <v-list-item-action>
                <v-icon>groups</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Clasificación Proveedores
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'Proveedor'}">
              <v-list-item-action>
                <v-icon>person</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Proveedores
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
                  <v-list-item :to="{ name: 'Compras'}">
              <v-list-item-action>
                <v-icon>receipt</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Compras
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
 
 
        <template v-if="esAdministrador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Accesos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'roles'}">
              <v-list-item-action>
                <v-icon>groups</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Roles
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'usuarios'}">
              <v-list-item-action>
                <v-icon>people</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Usuarios
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        
        <template v-if="esAdministrador || esAlmacenero || esVendedor || esComprador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Consultas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'consultaexistencias'}">
              <v-list-item-action>
                <v-icon>help_outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Existencia Productos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'consultaventas'}">
              <v-list-item-action>
                <v-icon>receipt</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Resumen de Venta
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'consultaminimos'}">
              <v-list-item-action>
                <v-icon>inventory</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Consultar Minimos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <template v-if="esAdministrador">
            <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title>
                  Graficos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'graficaventas'}">
              <v-list-item-action>
                <v-icon>poll</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Grafica de Ventas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'dashboardfinancieros'}">
              <v-list-item-action>
                <v-icon>insights</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title slot="activator">
                  Razones Financieras
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>
        </template>


      </v-list>
    </v-navigation-drawer>
    <v-app-bar v-if="logueado"
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-3"
      >
        <v-app-bar-nav-icon  @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          <router-link to="/" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" role="link">MCSYSTEMS</span>
          </router-link>
      </v-toolbar-title>
     
      <v-spacer></v-spacer>
      
    <!--   <v-btn
        icon
        large
      >
        <v-avatar
          size="32px"
          item
        >
          <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
          >
          </v-img>
          </v-avatar>    
      </v-btn> -->
      
     <a target="_black" href="../MCWEBMANUAL/MCSYSTEM_MANUAL_PDF.pdf">
      <v-icon size="32px"
          item >help</v-icon>
    </a>
      <v-btn @click="salir" v-if="logueado" icon>
        <v-icon>logout</v-icon>
      </v-btn>

    </v-app-bar>
    <v-main>
      <v-container
        fluid
        fill-height
      >
        <v-row class="fill-height">
            <v-col cols="12" class="fill-height">
              <router-view></router-view>
            </v-col>
        </v-row>
      </v-container>
    </v-main>
    <!-- <v-btn
      bottom
      color="pink"
      dark
      fab
      fixed
      right
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn> -->
    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <!-- <v-card>
        <v-card-title class="grey darken-2">
          Create contact
        </v-card-title>
        <v-container grid-list-sm>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              align-center
              justify-space-between
            >
              <v-layout align-center>
                <v-avatar
                  size="40px"
                  class="mr-3"
                >
                  <img
                    src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png"
                    alt=""
                  >
                </v-avatar>
                <v-text-field
                  placeholder="Name"
                ></v-text-field>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                prepend-icon="business"
                placeholder="Company"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                placeholder="Job title"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                prepend-icon="mail"
                placeholder="Email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                type="tel"
                prepend-icon="phone"
                placeholder="(000) 000 - 0000"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                prepend-icon="notes"
                placeholder="Notes"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
          >More</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            text
            @click="dialog = false"
          >Save</v-btn>
        </v-card-actions>
      </v-card> -->
    </v-dialog>
  </v-app>
</div>
</template>

<script>
export default {
  name: 'App',
  data () {
    
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      dialog:false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },
  computed: {
    logueado(){
      return this.$store.state.usuario;
    },
    esAdministrador(){
      return this.$store.state.usuario && this.$store.state.usuario.rol =='Administrador';
    },
    esAlmacenero(){
      return this.$store.state.usuario && this.$store.state.usuario.rol =='Bodega';
    },
    esComprador(){
      return this.$store.state.usuario && this.$store.state.usuario.rol =='Compras';
    },
    esContabilidad(){
      return this.$store.state.usuario && this.$store.state.usuario.rol =='Contabilidad';
    },
    esVendedor(){
      return this.$store.state.usuario && this.$store.state.usuario.rol =='Vendedores';
    }
  },
  created(){
    this.$store.dispatch("autoLogin");
  },
  methods:{
    salir(){
      this.$store.dispatch("salir");
    }
  }
}
</script>